import styled from 'styled-components'

export const Wrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: end;
  gap: 10px;
  padding: 18px;
  box-sizing: border-box;
  margin-top: 20px;
  border-radius: 4px;
  background-color: var(--grey-25);

  button {
    width: max-content;
    margin-left: auto;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const PriceHeading = styled.div`
  font-weight: var(--font-regular);
  font-size: 14px;
`
